import useSearchParamOrDefaultProps from '../hooks/useSearchParamOrDefaultProps.js';
import classNames from 'classnames';
import styles from './ArticleLogInGate.module.css';

function ArticleLogInGate() {
  const { articleTitle, callToActionButtonText } =
    useSearchParamOrDefaultProps();

  return (
    <div className={styles.background}>
      <div className={styles.template}>
        <div className={styles['top-flexBox']}>
          <div
            className={styles['header-flexBox']}
            style={{ flexDirection: 'column' }}
          >
            <div>
              <svg
                width="124"
                height="19"
                viewBox="0 0 124 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={classNames(styles.logo, styles['LogoHeader-logo'])}
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M14.4617 2.86352C14.8606 2.22896 15.5241 1.56468 16.2376 1.283C17.4666 0.737387 19.1141 0.97136 20.1165 1.83318C21.0856 2.69091 21.578 3.86413 21.3437 5.17615C21.5839 5.13348 21.823 4.98437 22.0752 4.90047C23.5829 4.48694 25.1738 4.93595 26.1393 6.19331C26.8632 7.09205 27.0526 8.48701 26.6179 9.57081C26.4028 10.1145 26.033 10.6064 25.5545 11.0245L25.6044 11.0734C27.0046 11.1391 28.382 12.1992 28.8057 13.4982C29.267 14.8093 28.8613 16.2115 27.8769 17.1677C27.0716 17.942 26.0399 18.2113 24.8899 18.187H4.03254C2.31739 18.2237 0.995907 17.4839 0.283372 16.0007C-0.275878 14.7249 0.000179515 13.0969 1.04487 12.1268C1.70352 11.4567 2.52579 11.1808 3.41769 11.0437C2.41015 10.1334 1.92471 8.88663 2.20766 7.5528C2.41015 6.4678 3.35593 5.37273 4.44245 4.99612C5.40299 4.62502 6.69963 4.68999 7.57947 5.19318L7.60948 5.15746C7.3445 3.6841 8.01348 2.35458 9.26903 1.54023C10.388 0.803792 12.1735 0.821771 13.2687 1.60639C13.761 1.9003 14.1657 2.40348 14.4617 2.86352Z"
                  fill="white"
                ></path>
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M19.5665 2.37977C18.7192 1.67186 17.3421 1.52203 16.365 2.07364C15.4323 2.55932 14.8782 3.48083 14.8721 4.47929L14.9097 4.51693L16.1328 4.52867C16.2125 4.58261 16.3412 4.5759 16.365 4.68977C15.8685 5.06254 15.0197 5.39097 15.1233 6.16265L16.4347 14.2112L16.4654 14.1755L20.0844 6.24104C20.5519 5.4497 20.8152 4.2959 20.3684 3.41491C20.2021 3.02463 19.9112 2.67823 19.5665 2.37977Z"
                  fill="#645FA9"
                ></path>
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M12.5877 14.1617L14.062 4.94716C14.1659 4.27665 13.9951 3.6723 13.7001 3.13891C13.3793 2.62493 12.8641 2.20517 12.3228 1.97743C11.3014 1.55791 10.0186 1.76767 9.23815 2.54007C8.46189 3.28418 8.14376 4.36678 8.48699 5.4036L12.1889 13.4493L12.5673 14.1922C12.5818 14.1872 12.5922 14.1757 12.5877 14.1617Z"
                  fill="#C8234A"
                ></path>
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M25.7212 7.019C26.2185 7.84534 26.108 9.09671 25.5549 9.86239C25.2119 10.4023 24.6451 10.6707 24.1665 11.0243L16.5014 16.1497H16.4834L16.5693 15.9056L20.6314 6.97154C21.2413 5.91722 22.4014 5.38431 23.6321 5.54613C24.4726 5.69571 25.3148 6.22958 25.7212 7.019Z"
                  fill="#0088CF"
                ></path>
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M3.94653 10.4262L12.4709 16.1497H12.5378L8.30982 6.97155C7.59483 5.7372 6.08537 5.22803 4.74494 5.70844C3.92685 6.00809 3.23917 6.76179 3.01871 7.57063C2.72174 8.64844 3.08022 9.71282 3.94653 10.4262Z"
                  fill="#F26F21"
                ></path>
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M27.5952 16.3137C28.2032 15.5708 28.3695 14.3722 27.9458 13.4984C27.668 12.9005 27.0798 12.2998 26.4538 12.0617C25.6399 11.6839 24.5113 11.7673 23.7668 12.2343L16.1523 17.3954L25.2421 17.3908C26.1879 17.4138 26.9924 17.024 27.5952 16.3137Z"
                  fill="#0DB04B"
                ></path>
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M12.8254 17.3951L5.21171 12.2343C4.46645 11.7671 3.33787 11.6836 2.52593 12.0614C1.89902 12.2995 1.31073 12.9003 1.03271 13.4981C0.61001 14.3722 0.776334 15.5708 1.38356 16.3135C1.98562 17.0238 2.79092 17.4136 3.73596 17.3906L12.8254 17.3951Z"
                  fill="#FCB813"
                ></path>
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M46.4556 7.95313C46.1144 6.33978 44.755 5.90947 43.2364 5.77498C38.3156 5.32909 37.4493 8.90844 37.4493 10.418C37.4493 13.002 38.2228 15.1353 43.0475 15.1353C43.9394 15.1353 46.3956 14.2445 46.3956 12.7925H53.3334C53.0505 17.0963 45.6324 18.1211 42.3942 18.1211C35.6879 18.1211 29.9438 16.9062 30.2258 10.4772C30.4258 5.88765 34.8799 2.66094 43.7423 2.85871C48.6793 2.97546 53.4321 4.47663 53.4535 7.95313H46.4556Z"
                  fill="black"
                ></path>
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M116.027 7.61011C115.683 5.99676 114.323 5.56645 112.798 5.43196C107.883 4.98607 107.017 8.56542 107.017 10.075C107.017 12.659 107.785 14.7923 112.613 14.7923C113.51 14.7923 115.963 13.9015 115.963 12.4495H122.9C122.627 16.7533 115.2 17.7781 111.96 17.7781C105.256 17.7781 99.5106 16.5632 99.7901 10.1342C99.9908 5.54464 104.451 2.31792 113.309 2.5157C118.251 2.63244 122.998 4.13361 123.02 7.61011H116.027Z"
                  fill="black"
                ></path>
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M54.7432 2.82886H63.7512L71.4405 13.3219L71.5012 2.82886H77.2771V17.4016H68.6489L60.58 6.90348L60.5207 17.4016H54.7432V2.82886Z"
                  fill="black"
                ></path>
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M85.3981 14.3472H87.2111C90.5814 14.3472 91.8111 13.9987 91.8111 12.8712C91.8111 11.6553 90.2522 11.2569 87.7352 11.2569H85.3981V14.3472ZM85.3981 8.4828H87.2111C90 8.4828 91.4861 8.27256 91.4861 7.14249C91.4861 5.93643 90.2522 5.53033 87.7352 5.53033H85.3981V8.4828ZM79.0615 2.82886H90C95.2663 2.82886 98.3622 4.25595 98.3622 6.41804C98.3622 7.69194 97.0638 9.27197 94.1763 9.73608V9.77708C97.6462 9.97749 98.9256 12.1154 98.9256 13.396C98.9256 15.9692 95.9197 17.4016 90.0384 17.4016H79.0615V2.82886Z"
                  fill="black"
                ></path>
              </svg>
            </div>
          </div>
          <center className={classNames.articleTitle}>{articleTitle}</center>

          <center
            className={classNames.login}
            style={{ fontWeight: 'normal', padding: '16px 0' }}
          >
            Already have a CNBC account?
            <button
              style={{
                color: '#005594',
                fontWeight: 'normal',
                marginLeft: '4px',
              }}
              className={classNames(styles.link, styles.unbutton)}
            >
              Sign In
            </button>
          </center>
        </div>

        <div className={classNames(styles['button-container'])}>
          <button
            style={{ border: '1px solid #005594', background: '#005594' }}
            className={classNames(styles['checkout-button'], styles.unbutton)}
          >
            {callToActionButtonText}
          </button>
          <button
            style={{ border: '1px solid #005594', color: '#005594' }}
            className={classNames(
              styles['checkout-button'],
              styles.inverse,
              styles.unbutton,
            )}
          >
            Sign In
          </button>
        </div>
      </div>
    </div>
  );
}

ArticleLogInGate.displayName = 'ArticleLogInGate';

export default ArticleLogInGate;
